"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMentionedUsers = void 0;
const useMentionedUsers = (chatInfoAccess, mentionedUsersParser) => {
    const getDidMentionPatient = (mentionedUsers) => {
        return (mentionedUsers &&
            chatInfoAccess.isMentionedUserHasPatient(mentionedUsers));
    };
    const getDidMentionPhysician = (mentionedUsers) => {
        return (mentionedUsers &&
            chatInfoAccess.isMentionedUserHasPhysician(mentionedUsers));
    };
    function withMentionedUsers(message) {
        const { plainText, mentionedUsers } = mentionedUsersParser(message);
        const didMentionPatient = getDidMentionPatient(mentionedUsers);
        const didMentionPhysician = getDidMentionPhysician(mentionedUsers);
        return Object.assign(Object.assign(Object.assign({ body: plainText }, (mentionedUsers && mentionedUsers.length > 0 && { mentionedUsers })), (didMentionPatient && { isVisibleToPatient: didMentionPatient })), (didMentionPhysician && { isVisibleToPhysician: didMentionPhysician }));
    }
    const didMentionPatientOrPhysician = (chatMessage) => {
        const { mentionedUsers } = mentionedUsersParser(chatMessage);
        const didMentionPatient = getDidMentionPatient(mentionedUsers);
        const didMentionPhysician = getDidMentionPhysician(mentionedUsers);
        return didMentionPatient || didMentionPhysician;
    };
    return {
        withMentionedUsers,
        didMentionPatientOrPhysician,
    };
};
exports.useMentionedUsers = useMentionedUsers;
